module.exports = __webpack_public_path__ + "img/ring_r_i_null_null.c1da110d.png";